import styled from 'styled-components';
const Parent = styled.div`
  display: flex;
`;
const SalesUtilityContainer = styled.div`
  margin-top: 100px;
`;
const NavBarContainer = styled.div`
  border: 2px solid #d4d4d4;
  height: 50px;
`;
const NavBar = styled.nav`
  font-size: 19px;
  font-weight: 900;
  padding: 10px;
  margin-left: 40px;
`;
const PaymentAndGenerateLinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  min-height: 100vh;
`;
const LeftContainer = styled.div`
  border-right: 2px solid #d4d4d4;
  border-bottom: 2px solid #d4d4d4;
  flex: 2 2 auto;
`;
const LeftContent = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
`;
const MappedContent = styled.div`
  flex: 1;
  margin-right: 15px;
  font-size: 17px;
  font-weight: 900;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
const RightContainer = styled.div`
  flex: 3 3 700px;
`;

const ContentTitle = styled.span`
  font-weight: ${props => {
    return props.isSelected ? '600' : '400';
  }};
  min-width: 200px;
  padding-bottom: 7px;
  border-bottom: 1px solid #d4d4d4;

  &:hover {
    font-weight: 900;
    color: black;
  }
`;
export default {
  Parent,
  SalesUtilityContainer,
  NavBarContainer,
  NavBar,
  PaymentAndGenerateLinkContainer,
  LeftContainer,
  LeftContent,
  MappedContent,
  RightContainer,
  ContentTitle
};



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/styles.js